/**
 * Create physic world
 * */

export default {
    initPhysic(){

        // Physics configuration

        this.collisionConfiguration = new Ammo.btDefaultCollisionConfiguration();
        this.dispatcher = new Ammo.btCollisionDispatcher( this.collisionConfiguration );
        this.broadphase = new Ammo.btDbvtBroadphase();
        this.solver = new Ammo.btSequentialImpulseConstraintSolver();
        this.physicsWorld = new Ammo.btDiscreteDynamicsWorld( this.dispatcher, this.broadphase, this.solver, this.collisionConfiguration );
        this.physicsWorld.setGravity( new Ammo.btVector3( 0, - 9.8, 0 ) );

        this.transformAux1 = new Ammo.btTransform();

        this.dynamicObjects = [] // physic world's objects

        return this
    },
    updatePhysics(deltaTime){
        this.physicsWorld.stepSimulation( deltaTime, 10 );

        // Update objects
        for ( let i = 0, il = this.dynamicObjects.length; i < il; i ++ ) {

            let objThree = this.dynamicObjects[ i ];
            let objPhys = objThree.userData.physicsBody;
            let ms = objPhys.getMotionState();
            if ( ms ) {

                ms.getWorldTransform( this.transformAux1 );
                let p = this.transformAux1.getOrigin();
                let q = this.transformAux1.getRotation();
                objThree.position.set( p.x(), p.y(), p.z() );
                objThree.quaternion.set( q.x(), q.y(), q.z(), q.w() );

            }

        }
    },
}